import WebAddressFormPanel from './WebAddressFormPanel';

export default WebAddressFormPanel;


// WEBPACK FOOTER //
// ./src/components/forms/WebAddressFormPanel/index.js